// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../Applications/Hyland.Web.PublicAccess.Client/node_modules/css-loader/index.js!./infragistics.ui.grid.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../Applications/Hyland.Web.PublicAccess.Client/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../Applications/Hyland.Web.PublicAccess.Client/node_modules/css-loader/index.js!./infragistics.ui.grid.css", function() {
			var newContent = require("!!../../../../../../../Applications/Hyland.Web.PublicAccess.Client/node_modules/css-loader/index.js!./infragistics.ui.grid.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// M:/_work/2/s/Core/OnBase.NET/third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/css/structure/modules/infragistics.ui.grid.css
// module id = 124
// module chunks = 0